import { render, staticRenderFns } from "./TableAmountInputs.vue?vue&type=template&id=5e9ecbf4&"
import script from "./TableAmountInputs.vue?vue&type=script&lang=js&"
export * from "./TableAmountInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports